import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import EventEmitter, {
  SHOW_POPUP_ERROR,
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { selectUserType } from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { USER_TYPE } from '../../../../utils/authorization'
import { TYPE_DELETE } from '../../../constant'
import { DeletePortfolio } from '../../../savedPortfolios/portfoliosOverview/components/DeletePortfolio'
import {
  changeFragment,
  selectNameCompanySearch,
  selectTypePortfolioSelect,
} from '../../../savedPortfolios/portfoliosOverview/store/slice/sliceComponent'
import {
  delDeletePortfolio,
  getHeaderSavedPortfolio,
  getIdPortfolioAllByOrg,
  getSearchPortfolioAll,
  postDuplicatePortfolio,
} from '../../../savedPortfolios/portfoliosOverview/store/thunk'
import { PORTFOLIO_VALUES } from '../constant'
import {
  removeIdInListIdAll,
  selectCheckboxPortfolio,
  selectDataReduxTableSavedPortfolio,
  selectIDCompanySearch,
  selectTotal,
} from '../store/slice/slice'

export const CustomTdAction = ({ rowId }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isShowDelete, setIsShowDelete] = useState(false)

  const userType = useSelector(selectUserType)
  const listCheckbox = useSelector(selectCheckboxPortfolio(['listIdsSelected']))
  const isCanNavigate = !Object.values(listCheckbox).some(Boolean)
  const dataTable = useSelector(selectDataReduxTableSavedPortfolio(rowId))
  const { totalPortfolios } = useSelector(selectTotal)
  const textSearch = useSelector(selectNameCompanySearch)
  const typeSearch = useSelector(selectTypePortfolioSelect)
  const idSearch = useSelector(selectIDCompanySearch)

  const textValidate = UseI18n('library.main.VALIDATE_PORTFOLIO')

  const handelDuplicatePortfolio = () => {
    if (totalPortfolios >= 300) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [textValidate],
      })
      return null
    }

    dispatch(postDuplicatePortfolio({ portfolioId: rowId }))
      .unwrap()
      .then(() => {
        if (
          typeSearch.value === PORTFOLIO_VALUES.PORTFOLIO ||
          (typeSearch.value === PORTFOLIO_VALUES.COMPANY && !idSearch)
        ) {
          dispatch(
            getSearchPortfolioAll({
              InputSearch: textSearch,
            }),
          )
        }

        if (typeSearch.value === PORTFOLIO_VALUES.COMPANY && !!idSearch) {
          dispatch(
            getIdPortfolioAllByOrg({
              OrganizationId: idSearch,
            }),
          )
        }
        dispatch(changeFragment())
        dispatch(getHeaderSavedPortfolio())
      })
      .catch(() => {})
  }

  const handleDelete = () => {
    setIsShowDelete(true)
  }

  const handelViewInsight = () => {
    if ([USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId)) {
      navigate(
        `${COMPONENTS.portfolioInsights.components.summary.route}?library=true&portfolio=${rowId}`,
      )
    } else {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  const handleConfirmDelete = () => {
    dispatch(
      delDeletePortfolio({
        portfolioIds: [rowId],
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(removeIdInListIdAll([rowId]))
        dispatch(changeFragment())
        setIsShowDelete(false)
      })
      .catch(() => {})
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <Element
        className={['dFlex alignItemsCenter'].join(' ')}
        style={{
          gap: 12,
          pointerEvents: !isCanNavigate ? 'none' : 'auto',
        }}
      >
        {[USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId) ? (
          <Tooltip
            tooltipContent="library.detailsPortfolios.VIEW_PORTFOLIO_INSIGHT"
            isI18n
          >
            <Icon
              onClick={handelViewInsight}
              className="icon-view-insight"
              style={{ fontSize: 18, color: '#006aa6' }}
            />
          </Tooltip>
        ) : (
          <Tooltip
            tooltipContent="library.savePortfolio.UPGRADE_ACCOUNT"
            isI18n
          >
            <Icon
              onClick={handelViewInsight}
              className="icon-view-insight"
              style={{ fontSize: 18, color: '#9c9c9c' }}
            />
          </Tooltip>
        )}

        <Tooltip tooltipContent="library.savePortfolio.DUPLICATE" isI18n>
          <Icon
            className="icon-file-coppy"
            style={{ fontSize: 16, color: '#9c9c9c' }}
            onClick={handelDuplicatePortfolio}
          />
        </Tooltip>
        <Tooltip tooltipContent="library.main.DELETE" isI18n>
          <Icon
            onClick={handleDelete}
            className="icon-trash-fill"
            style={{ fontSize: 15, color: '#9c9c9c' }}
          />
        </Tooltip>
      </Element>
      {isShowDelete && (
        <DeletePortfolio
          isShow={isShowDelete}
          setShow={setIsShowDelete}
          handleDelete={handleConfirmDelete}
          renderContent={() => (
            <>
              <Element elementName="p" style={{ overflowWrap: 'break-word' }}>
                <Translate
                  value="library.savePortfolio.TEXT_DELETE_PORTFOLIO"
                  name={dataTable?.portfolioName}
                  dangerousHTML
                />
              </Element>
            </>
          )}
        />
      )}
    </div>
  )
}
